// extracted by mini-css-extract-plugin
export default {"element":"BurgerConstructorCard_element__NALof","onHover":"BurgerConstructorCard_onHover__676fp"};